import CycleMeasurement from '../enums/cycle-measurement';
import CycleSettings from '../enums/cycle-setting.enum';
import { IBaseEntity } from './base-types';
export interface IRecipeEditable {
  name: string;
  mode?: CycleSettings.PostWeld;
  rateUpperTolerance: number;
  rateLowerTolerance: number;
  holdUpperTolerance: number;
  holdLowerTolerance: number;
}

export interface IPreHeatRecipeEditable {
  name?: string;
  mode: CycleSettings.PreHeat;
  rate: number;
  finalTemp: number;
  soakUpper: number;
  soakLower: number;
}

export type IPreHeatRecipe = IBaseEntity & IPreHeatRecipeEditable;
type IPostWeldRecipe = IBaseEntity & IRecipeEditable;

export type IRecipe =
  | ({ mode: CycleSettings.PostWeld } & IPostWeldRecipe)
  | ({ mode: CycleSettings.PreHeat } & IPreHeatRecipe);

export enum StepMode {
  Rate = 'Rate',
  Soak = 'Soak',
}

export interface IRecipeStepEditable {
  mode: StepMode;
  durationDays?: number;
  durationHours?: number;
  durationMinutes?: number;
  durationMinutesTotal?: number;
  heatingRate: number;
  heatingLimit: number;
  order: number;
  isCelsius: boolean;
  duration?: number;
  units?: CycleMeasurement;
  created_at?: string;
  updated_at?: string;
  recipeId?: string;
}



export interface IRecipeStepRecipeId {
  recipeId: string;
}

export type IRecipeStep = IBaseEntity & IRecipeStepEditable & IRecipeStepRecipeId;

export interface IReorderedRecipeStep {
  id: string;
  order: number;
}
